/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseEntity} from './base-entity';
import {Reader} from './reader';
import {Function} from './function';

export class Antenna extends BaseEntity {
  reader: Reader;
  functions: Function[];
}
